"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var moment = require("moment-timezone");
var debug = require("debug")("knack.formatter.formatters.date");
var _ = require("lodash");
var isValidDate = function isValidDate(date, datetimeFormat) {
  return Boolean(datetimeFormat) && moment(date).isValid();
};
var getMomentDateTimeFormatFromValueAndFormat = function getMomentDateTimeFormatFromValueAndFormat(value, format, fromValue) {
  var dateFormat = "";
  var timeFormat = "";
  var datetimeFormat = "";
  if (!format) {
    format = {};
  }
  switch (format.dateFormat) {
    case "Ignore Date":
      dateFormat = "";
      break;
    case "dd/mm/yyyy":
      dateFormat = "DD/MM/YYYY";
      break;
    case "M D, yyyy":
      dateFormat = "MMMM DD, YYYY";
      break;
    case "mm/dd/yyyy":
    default:
      dateFormat = "MM/DD/YYYY";
      break;
  }
  if (!value.all_day) {
    switch (format.timeFormat) {
      case "Ignore Time":
        timeFormat = "";
        break;
      case "HH MM (military)":
        timeFormat = "HH:mm";
        break;
      case "HH:MM am":
      default:
        timeFormat = "h:mma";
        break;
    }
  }
  if (dateFormat && (!fromValue || fromValue && fromValue.date !== value.date)) {
    datetimeFormat = dateFormat;
    if (timeFormat && format.timeFormat) {
      datetimeFormat += " ";
    }
  }
  if (timeFormat && format.timeFormat) {
    datetimeFormat += timeFormat;
  }
  return datetimeFormat;
};
var parseDateForFormat = function parseDateForFormat(value, format, fromValue) {
  var date;
  if (!_.isNil(value.date) || !_.isNil(value.hours)) {
    var dateValue = value.date ? value.date : "";
    if (!_.isNil(value.hours)) {
      if (_.isNil(value.date)) {
        dateValue = "01/01/2012";
      }
      dateValue += " ".concat(value.hours, ":").concat(value.minutes);
      if (value.am_pm) {
        dateValue += " ".concat(value.am_pm.toLowerCase());
      }
    }
    var datetimeFormat = getMomentDateTimeFormatFromValueAndFormat(value, format, fromValue);
    if (datetimeFormat.indexOf("MMMM DD, YYYY") > -1) {
      datetimeFormat = datetimeFormat.replace("MMMM DD, YYYY", "MM/DD/YYYY");
    }
    date = moment(dateValue, datetimeFormat);
  } else if (value.time) {
    var _dateValue = value.date ? value.date : "";
    if (!value.date) {
      _dateValue = "01/01/2012";
    }
    _dateValue += " ".concat(value.time);
    var _datetimeFormat = "MM/DD/YYYY hh:mm a";
    date = moment(_dateValue, _datetimeFormat);
  } else {
    date = moment(new Date(value));
  }
  if (format && format.timeFormat === "HH MM (military)" && value.am_pm === "PM") {
    date.add(12, "hours");
  }
  return date;
};
var formatTo = function formatTo(value, format, fromValue) {
  if (!value || _.isNil(value.date) && _.isNil(value.hours)) {
    return "";
  }
  var date = parseDateForFormat(value, format, fromValue);
  var datetimeFormat = getMomentDateTimeFormatFromValueAndFormat(value, format, fromValue);
  var formatted = date.format(datetimeFormat);
  if (value.to) {
    to = formatDate(value.to, format, value);
    if (to) {
      formatted += " to ".concat(to);
    }
  }
  if (isValidDate(date, datetimeFormat)) {
    return formatted;
  }
  return "";
};
var getMomentDateFormatFromKnackDateFormat = function getMomentDateFormatFromKnackDateFormat(dateFormat) {
  switch (dateFormat) {
    case "Ignore Date":
      return "";
    case "dd/mm/yyyy":
      return "DD/MM/YYYY";
    case "M D, yyyy":
      return "MMMM DD, YYYY";
    case "mm/dd/yyyy":
    default:
      return "MM/DD/YYYY";
  }
};

/**
 * @alias "formatters.date"
 * @param {Object} value Value to be formatted
 * @param {String} value.date
 * @param {String} value.hours
 * @param {String} value.minutes
 * @param {String} value.am_pm 'am' or 'pm'
 * @param {Boolean} [value.all_day]
 * @param {Object} [format]  Format
 * @param {String} [format.date_format] Moment-compliant date format
 * @param {String} [format.time_format] 'Ignore Time', 'HH MM (military)', 'HH:MM am'
 * @param {Object} [fromValue]
 * @param {String} [fromValue.date]
 * @return {String}
 */
var dateFormatter = function dateFormatter(value, format, fromValue) {
  if (!value || (_typeof(value.date) !== "undefined" || _typeof(value.hours) !== "undefined") && !value.hours && !value.date) {
    return "";
  }
  var dateFormat = "MM/DD/YYYY hh:mm a";
  var date = value;
  if (!moment.isMoment(value) && (!_.isNil(value.date) || !_.isNil(value.hours))) {
    var dateValue = value.date || "";
    if (!_.isNil(value.hours)) {
      if (_.isNil(value.date)) {
        dateValue = "01/01/2012";
      }
      dateValue += " ".concat(value.hours, ":").concat(value.minutes || "00");
      if (value.am_pm) {
        dateValue += " ".concat(value.am_pm.toLowerCase());
      }
    }
    date = moment(dateValue, dateFormat);
  } else if (!moment.isMoment(value)) {
    date = moment(new Date(value));
  }
  dateFormat = getMomentDateFormatFromKnackDateFormat(format.date_format);
  var timeFormat = "";
  if (!value.all_day) {
    switch (format.time_format) {
      case "Ignore Time":
        timeFormat = "";
        break;
      case "HH MM (military)":
        timeFormat = "HH:mm";
        break;
      case "HH:MM am":
      default:
        timeFormat = "h:mma";
        break;
    }
  }
  var datetimeFormat = "";
  if (dateFormat && (!fromValue || fromValue && fromValue.date !== value.date)) {
    datetimeFormat = dateFormat;
    if (timeFormat) {
      datetimeFormat += " ";
    }
  }
  if (timeFormat) {
    datetimeFormat += timeFormat;
  }
  var formatted = date.format(datetimeFormat);
  if (value.to) {
    var _to = formatTo(value.to, format, value);
    if (_to) {
      formatted += " to ".concat(_to);
    }
  }
  if (isValidDate(date, datetimeFormat)) {
    return formatted;
  }
  return "";
};
module.exports = dateFormatter;